// extracted by mini-css-extract-plugin
module.exports = {"alistBasic":"icons_alistBasic__4swzd"};